import React from "react";
import Logo from "../../assets/svg/mawaloglogo1.svg";
const PoweredBy = ({ marginTop = "10px", paddingBottom = "px" }) => {
  const wesbiteUrl = process.env.REACT_APP_WEBISTE_URL;
  return (
    <div
      className="w-100 d-flex flex-row align-items-center"
      style={{ backgroundColor: "#EFF6FE" }}
    >
      <div
        className="sidebar-powered"
        style={{
          backgroundColor: "#471070",
          height: "32px",
          //   boxShadow: "0px 0px 0px 0px #00000012",
        }}
      ></div>

      <div
        className="w-100 d-flex justify-content-center align-items-center"
        style={{
          paddingBottom,
          fontWeight: "400",
          fontSize: "14px",
          color: "#172B4D",
          backgroundColor: "#EFF6FE",
            // paddingTop: "6px",
            // marginTop:''
        }}
      >
        <span className="me-1">Powered by</span>
        <img
          src={Logo}
          alt="Mawa Logo"
          style={{
            height: "16px",
            cursor: "pointer",
            marginTop: "2px",
          }}
          onClick={() => {
            window.open(wesbiteUrl, "_blank", "noopener,noreferrer");
          }}
        />
      </div>
    </div>
  );
};

export default PoweredBy;
